import React, { forwardRef } from 'react';
import TextareaAutosize, {
  TextareaAutosizeProps,
} from 'react-textarea-autosize';
import styled from 'styled-components';
import { defaultInputStyles } from './inputStyles';
import { getScrollBarStyles } from '../../config/styles';
import { IFieldDesignProps, IStyledFieldDesignProps } from './types';

interface IProps
  extends Omit<TextareaAutosizeProps, 'onChange'>,
    IFieldDesignProps {
  onChange?: (value: string) => void;
}

const TextArea = styled(TextareaAutosize)<IStyledFieldDesignProps>`
  ${defaultInputStyles};
  resize: none;
  white-space: normal;
  ${getScrollBarStyles(2)}
`;

export default forwardRef<HTMLTextAreaElement, IProps>(
  (
    {
      minRows = 1,
      maxRows = 3,
      onChange,
      hasError,
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (disabled) {
        return;
      }
      if (onChange) {
        onChange(event.target.value);
      }
    };

    return (
      <TextArea
        {...props}
        ref={ref}
        onChange={handleChange}
        minRows={minRows}
        maxRows={maxRows}
        disabled={disabled}
        $hasError={hasError}
      />
    );
  },
);
